<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户账号">
                  <el-input style="width: 200px;" v-model="queryForm.userName"></el-input>
              </el-form-item>
              <el-form-item label="手机号码">
                  <el-input style="width: 200px;" v-model="queryForm.userMobile"></el-input>
              </el-form-item>
              <el-form-item label="用户昵称">
                  <el-input style="width: 200px;" v-model="queryForm.userNickname"></el-input>
              </el-form-item>
              <el-form-item label="真实姓名">
                  <el-input style="width: 200px;" v-model="queryForm.userRealname"></el-input>
              </el-form-item>
              <el-form-item label="用户等级">
                  <el-select size="small" clearable v-model="queryForm.gradeId" placeholder="请选择" style="width: 200px">
                      <el-option v-for="role in mppGradeList" :key="role.id" :label="role.gradeName" :value="role.id"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppUserList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppUser(null)"
        >修改</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMppUserList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mppUserList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="userHeader"
            label="头像"
            width="180"
        >
            <template slot-scope="scop">
                <el-image
                    @click='updateSrcList(scop.row.userHeader)'
                    style="width: 30px; height: 30px"
                    :src="scop.row.userHeader"
                    :preview-src-list="srcList"
                > </el-image>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userName"
        label="账号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userMobile"
        label="手机"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="wxPublicOpenid"
        label="微信公众号openId"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="wxAppOpenid"
        label="微信小程序openId"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="wxUnionid"
        label="微信统一ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="aliLifeOpenid"
        label="支付宝生活号openId"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMppUser(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMppUser(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppUserStates[mppUserState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppUser"
          ref="mppUserForm"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="账号"
            prop="userName"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mppUser.userName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="手机"
            prop="userMobile"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mppUser.userMobile"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="微信公众号openId"
            prop="wxPublicOpenid"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mppUser.wxPublicOpenid"
              :disabled="mppUserState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="微信小程序openId"
            prop="wxAppOpenid"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mppUser.wxAppOpenid"
              :disabled="mppUserState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="微信统一ID"
            prop="wxUnionid"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mppUser.wxUnionid"
              :disabled="mppUserState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="支付宝生活号openId"
            prop="aliLifeOpenid"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mppUser.aliLifeOpenid"
              :disabled="mppUserState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppUserState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { uploadAvatar } from '@/api/user';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppUserList();
                    this.getMppUserList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppUserList();
                    this.getMppUserList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userName: '', //用户账号
                     userMobile: '', //手机号码
                     userHeader: '', //用户头像
                     userNickname: '', //昵称
                     wxPublicOpenid: '', //微信公众号openId
                     wxAppOpenid: '', //微信小程序openId
                     wxUnionid: '', //微信统一ID
                     aliLifeOpenid: '', //支付宝生活号openId
                     gradeId: ''
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppUserState: 'add',
                mppUserStates: {
                    add: '新建用户',
                    check: '查看用户',
                    edit: '修改用户'
                },

                multipleSelection: [],
                mppUserList: [],
                mppUser: {
                    id: '', //
                    userName: '', //用户账号
                    userMobile: '', //手机号码
                    userHeader: '', //用户头像
                    gradeId: '', //等级id
                    wxPublicOpenid: '', //微信公众号openId
                    wxAppOpenid: '', //微信小程序openId
                    wxUnionid: '', //微信统一ID
                    aliLifeOpenid: '', //支付宝生活号openId
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    userName: [{ required: true, message: '用户账号不能为空', trigger: 'blur' }],
                    userMobile: [{ required: true, message: '手机号码不能为空', trigger: 'blur' }],
                    userHeader: [{ required: true, message: '用户头像不能为空', trigger: 'blur' }],
                    gradeId: [{ required: true, message: '等级id不能为空', trigger: 'blur' }],
                    wxPublicOpenid: [{ required: true, message: '微信公众号openId不能为空', trigger: 'blur' }],
                    wxAppOpenid: [{ required: true, message: '微信小程序openId不能为空', trigger: 'blur' }],
                    wxUnionid: [{ required: true, message: '微信统一ID不能为空', trigger: 'blur' }],
                    aliLifeOpenid: [{ required: true, message: '支付宝生活号openId不能为空', trigger: 'blur' }],
                },
                mppGradeList: [],
                srcList: ['']
            };
        },
        created() {
            this.getMppUserList();
            this.getMppGradeList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            updateSrcList(src){
                this.srcList[0] = src
            },
            getMppGradeList() {
                this.loading = true;
                console.log(this.queryForm);
                get(`/mpp/grade/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppGradeList = res.page.list;
                    }
                });
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!types.includes(file.type)) {
                    this.$message({
                        message: '只能上传图片格式的文件，png.jpg或者jpeg',
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                uploadAvatar(formData).then((res) => {
                    console.log({ res });
                    if (res.success) {
                        this.user.userHeader = res.url;
                    }
                });
            },
            resetMppUserList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppUserList = [];
            },
            resetDialog() {
                this.mppUserState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userName: '', //用户账号
                      userMobile: '', //手机号码
                      userHeader: '', //用户头像
                      gradeId: '', //等级id
                      wxPublicOpenid: '', //微信公众号openId
                      wxAppOpenid: '', //微信小程序openId
                      wxUnionid: '', //微信统一ID
                      aliLifeOpenid: '', //支付宝生活号openId
                };
                this.getMppUserList();
            },
            closeDialog() {
                this.showDialog = false
                this.mppUser = {
                      id: '', //
                      userName: '', //用户账号
                      userMobile: '', //手机号码
                      userHeader: '', //用户头像
                      gradeId: '', //等级id
                      wxPublicOpenid: '', //微信公众号openId
                      wxAppOpenid: '', //微信小程序openId
                      wxUnionid: '', //微信统一ID
                      aliLifeOpenid: '', //支付宝生活号openId
                };
            },
            submitForm() {
                if (this.mppUserState == 'add') {
                    this.$refs.mppUserForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/user/add`,{ ...this.mppUser }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppUserList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mppUserState == 'edit') {
                    this.$refs.mppUserForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.mppUser.mppGrade
                            delete this.mppUser.postList
                            delete this.mppUser.company;
                            delete this.mppUser.mppDept;
                            delete this.mppUser.mppRoleList;
                            delete this.mppUser.postIdList;
                            delete this.mppUser.currencyMoneyList;
                            delete this.mppUser.nodeLinearList;
                            delete this.mppUser.growth;
                            post(`/mpp/user/edit`,{ ...this.mppUser }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppUserList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMppUser() {
                this.showDialog = true;
                this.mppUserState = 'add';
            },
            checkMppUser(mppUserId) {
                console.log(mppUserId);
                this.currentMppUserId = mppUserId;

                this.getMppUserById();
                this.showDialog = true;
                this.mppUserState = 'check';
            },
            editMppUser(mppUserId) {
                console.log('mppUser', mppUserId);
                if (mppUserId) {
                    this.currentMppUserId = mppUserId;
                    this.getMppUserById();
                } else {
                    this.mppUser = { ...this.mppUser, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppUserState = 'edit';
            },
            deleteMppUser(mppUserId) {
                let ids = '';
                if (mppUserId) {
                    ids = mppUserId;
                } else {
                    ids = this.multipleSelection.map((mppUser) => mppUser.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/user/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppUserList();
                                this.getMppUserList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppUserList() {
                this.resetMppUserList();
                this.getMppUserList();
            },
            getMppUserList(query = {}) {
                this.loading = true;
                get(`/mpp/user/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppUserList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMppUserById() {
                get(`/mpp/user/get`,{ id: this.currentMppUserId }).then((res) =>{
                    if(res.success){
                      this.mppUser = { ...this.mppUser, ...res.mppUser };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppUserList() {
                //this.btnLoading = true;
                exprotExcel(`/mpp/user/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mpp/user/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/user/importData`,formData);
              this.refreshMppUserList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppUserList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppUserList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    button{
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.content {
    flex: 1;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.theme-color{
    & > span{
        margin-left: 3px;
    }
    color: #409eff;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}

::v-deep .el-dropdown{
    font-size: 12px;
    color: #409eff;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
.nameImg {
    -ms-transform: rotate(90deg); /* IE 9 */
    -webkit-transform: rotate(90deg); /* Safari and Chrome */
    transform: rotate(90deg);
}
</style>